const CashBackBannerIcon = ({
  fill = "#ED3A56",
  stroke = "#F1F2F6",
  fillCircle = "",
  width = "20",
  height = "20",
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.20317 1.05088C9.60332 0.523148 10.3967 0.523148 10.7968 1.05088L12.3253 3.06668C12.5437 3.35463 12.9004 3.50238 13.2584 3.45316L15.7645 3.10857C16.4207 3.01836 16.9816 3.57935 16.8914 4.23546L16.5468 6.74164C16.4976 7.09964 16.6454 7.45635 16.9333 7.67469L18.9491 9.20317C19.4769 9.60332 19.4769 10.3967 18.9491 10.7968L16.9333 12.3253C16.6454 12.5437 16.4976 12.9004 16.5468 13.2584L16.8914 15.7645C16.9816 16.4207 16.4207 16.9816 15.7645 16.8914L13.2584 16.5468C12.9004 16.4976 12.5437 16.6454 12.3253 16.9333L10.7968 18.9491C10.3967 19.4769 9.60332 19.4769 9.20317 18.9491L7.67469 16.9333C7.45635 16.6454 7.09964 16.4976 6.74164 16.5468L4.23546 16.8914C3.57935 16.9816 3.01836 16.4207 3.10857 15.7645L3.45316 13.2584C3.50238 12.9004 3.35463 12.5437 3.06668 12.3253L1.05088 10.7968C0.523148 10.3967 0.523148 9.60332 1.05088 9.20317L3.06668 7.67469C3.35463 7.45635 3.50238 7.09964 3.45316 6.74164L3.10857 4.23546C3.01836 3.57935 3.57935 3.01836 4.23546 3.10857L6.74164 3.45316C7.09964 3.50238 7.45635 3.35463 7.67469 3.06668L9.20317 1.05088Z"
      fill={fill}
      stroke={stroke}
    />
    <ellipse
      cx="11.868"
      cy="12.3621"
      rx="1.1375"
      ry="1.1375"
      stroke={stroke}
      fill={fillCircle}
      strokeLinejoin="round"
    />
    <ellipse
      cx="7.6375"
      cy="8.1375"
      rx="1.1375"
      ry="1.1375"
      stroke={stroke}
      fill={fillCircle}
      strokeLinejoin="round"
    />
    <path d="M13 7L6.5 13.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CashBackBannerIcon;
